enum RepairabilityIndexModalEnum {
	repairabilityIndexCard = 'repairabilityIndexCard'
}

export default RepairabilityIndexModalEnum;
